export const DEFAULT_ON_BEFORE_INIT_SCRIPT = `// Default onBeforeInit script
function onBeforeInit(serviceSchemeString, collectedParametersString, amountOptionString, senderAmountOptionString, payerString) {

    // Convert input strings to objects
    const serviceScheme = JSON.parse(serviceSchemeString)
    const collectedParameters = JSON.parse(collectedParametersString)
    // etc. for other parameters if needed

    // --------------------------------------------------
    // Add your code here
    // You can modify objects as needed
    // Example of modifying collectedParameters:
    // collectedParameters.originCountry = "ZW"
    // --------------------------------------------------

    // Form the result object
    const result = {
        serviceScheme: serviceScheme,
        parameters: collectedParameters
        // other optional parameters if needed, for example:
        // singleOrBeneficiaryAmount: ...,
        // remitterAmount: ...,
    }

    // Convert the result object back to a string and return it
    return JSON.stringify(result)
}
`;

export const DEFAULT_ON_BEFORE_CHECK_SCRIPT = `// Default onBeforeCheck script
function onBeforeCheck(serviceSchemeString, collectedParametersString, amountOptionString, senderAmountOptionString, payerString) {

    // Convert input strings to objects
    const serviceScheme = JSON.parse(serviceSchemeString)
    const collectedParameters = JSON.parse(collectedParametersString)
    // etc. for other parameters if needed

    // --------------------------------------------------
    // Add your code here
    // You can modify objects as needed
    // Example of modifying collectedParameters:
    // collectedParameters.originCountry = "ZW"
    // --------------------------------------------------

    // Form the result object
    const result = {
        serviceScheme: serviceScheme,
        parameters: collectedParameters
        // other optional parameters if needed, for example:
        // singleOrBeneficiaryAmount: ...,
        // remitterAmount: ...,
    }

    // Convert the result object back to a string and return it
    return JSON.stringify(result)
}
`;

export const DEFAULT_ON_INIT_SCRIPT = `// Default onInit script
function onBeforeInit(serviceSchemeString, collectedParametersString, amountOptionString, senderAmountOptionString, payerString) {

    // Convert input strings to objects
    const serviceScheme = JSON.parse(serviceSchemeString)
    const collectedParameters = JSON.parse(collectedParametersString)
    // etc. for other parameters if needed

    // --------------------------------------------------
    // Add your code here
    // You can modify objects as needed
    // Example of modifying collectedParameters:
    // collectedParameters.originCountry = "ZW"
    // --------------------------------------------------

    // Form the result object
    const result = {
        serviceScheme: serviceScheme,
        parameters: collectedParameters
        // other optional parameters if needed, for example:
        // singleOrBeneficiaryAmount: ...,
        // remitterAmount: ...,
    }

    // Convert the result object back to a string and return it
    return JSON.stringify(result)
}
`;

export const DEFAULT_ON_CHECK_SCRIPT = `// Default onCheck script
function onBeforeCheck(serviceSchemeString, collectedParametersString, amountOptionString, senderAmountOptionString, payerString) {

     // Convert input strings to objects
    const serviceScheme = JSON.parse(serviceSchemeString)
    const collectedParameters = JSON.parse(collectedParametersString)
    // etc. for other parameters if needed

    // --------------------------------------------------
    // Add your code here
    // You can modify objects as needed
    // Example of modifying collectedParameters:
    // collectedParameters.originCountry = "ZW"
    // --------------------------------------------------

    // Form the result object
    const result = {
        serviceScheme: serviceScheme,
        parameters: collectedParameters
        // other optional parameters if needed, for example:
        // singleOrBeneficiaryAmount: ...,
        // remitterAmount: ...,
    }

    // Convert the result object back to a string and return it
    return JSON.stringify(result)
}
`;
